import React, { Component } from 'react'
import PaymentTypeEditForm from "./form/edit.component.jsx"
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class PaymentTypeEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: {},
            form: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')

        const paymentTypeId = this.props.match.params.paymentTypeId
        AppContext.getApiClient().get('/payment-types/' + paymentTypeId).then(paymentType => {
            const form = <PaymentTypeEditForm paymentType={paymentType} />
            this.setState({
                form: form
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default PaymentTypeEdit


// WEBPACK FOOTER //
// ./src/payment-type/edit.component.jsx